import Router from "./routing/Router";
const App = () => {
  return (
    <>
      <Router />
    </>
  );
}

export default App;